import React, { Suspense } from 'react';
import { Spinner } from "react-bootstrap";

import Belt from '../components/Belt';
import Footer from '../components/Footer';
import BeltLogged from '../components/BeltLogged';

const BeltLeague = React.lazy(() => import('../leagueAppComponents/BeltLeague'));

class PageLeagueInfo extends React.Component {

  state = {
    data: [],
    newsCount: "",
    currentPage: "1",
    title: "RezerwujKort.pl - Wylogowany"
  }

  render() {

    var msg = this.props.location.state;
    var info = "";
    if (msg === undefined) {
      info = "";
    } else {
      info = <p> {msg} </p>;
    }

    var beltLeague;
    beltLeague = <div>
      <Suspense fallback={<div>
        <Spinner style={{ 'borderStyle': 'dotted', 'marginLeft': '50%' }} animation="border" />
      </div>}>
        <BeltLeague
          currentPage={""}
          club={this.props.match.params.club}
          league={this.props.match.params.club}
        />
      </Suspense>
    </div>

    return (

      <div>

        <Belt />

        <BeltLogged />



        <div id="content">
          <div class="container">
            <div class="main-subpage-info">

              {beltLeague}

              <p> {info} </p>
            </div>
          </div>
        </div>

        <Footer />

      </div>
    );
  }
}
export default PageLeagueInfo;
